import { CredentialChild, CredentialFather } from 'types/ProvidersProps';

export function updateCredentialRecursively(
	affiliates: CredentialFather[],
	newCredential: CredentialChild
): CredentialFather[] {
	return affiliates.map((affiliate) => ({
		...affiliate,
		credentials: affiliate.credentials.map((credential) =>
			credential.id === newCredential.id ? newCredential : credential
		)
	}));
}
